module.exports = __webpack_public_path__ + "img/Pria.38fbe016.svg";